export const wGooglePlusOneMetaData = {
    isRepeatable: false
}
